<template>
  <v-card
    v-if="chemical && valueFormatted"
    max-width="30rem"
    min-width="20rem"
    max-height="36rem"
    class="overflow-auto"
  >
    <ReplacedChemical
      :original-chemical="chemical"
      :secondary-name="headerName"
      :standardization-change="standardizationChange"
    />

    <v-divider class="mx-4 my-0" />

    <v-card-text>
      <b-table-lite
        :fields="popoverFields"
        :items="getTableItems()"
        borderless
        small
        stacked
        class="mb-0"
      >
        <template #cell(value)="data">
          <span :class="getClassForBooleanText(data.value)">
            {{ data.value }}
          </span>
        </template>

        <template #cell(confidence)="data">
          <span :style="getColorStyle(data.value)">
            {{ formatScientificWithBlankEmpty(data.value) }}
          </span>
        </template>
      </b-table-lite>
    </v-card-text>
  </v-card>

  <v-card
    v-else
    class="p-2"
  >
    {{ params?.column?.colDef?.headerTooltip }}
  </v-card>
</template>

<script>
import { formatScientificWithBlankEmpty } from '@/components/combined-predict/utils'
import { getClassForBooleanText, getColorStyle } from '@/components/combined-predict/models/utils/displayUtils'
import ReplacedChemical from '@/components/shared-table/components/ReplacedChemical.vue'

export default {
  name: 'AmenabilityTooltip',
  components: {
    ReplacedChemical,
  },
  data() {
    return {
      chemical: null,
      standardizationChange: null,
      valueFormatted: null,
      confidence: null,
      headerName: '',
      popoverFields: null,
      formatScientificWithBlankEmpty,
      getClassForBooleanText,
      getColorStyle,
    }
  },
  methods: {
    getPopoverFields(params) {
      return [
        { key: 'value', label: params?.column?.colDef?.headerName },
        { key: 'confidence', label: 'Confidence' },
      ]
    },

    getTableItems() {
      return [
        {
          value: this.valueFormatted,
          confidence: this.confidence,
        },
      ]
    },
  },

  beforeMount() {
    this.chemical = this.params?.data?.chemical
    this.standardizationChange = this.params?.standardizationChange
    this.valueFormatted = this.params?.valueFormatted
    this.predictionForProperty = this.params?.predictionForProperty
    this.confidence = this.params?.confidence
    this.headerName = this.params?.column?.colDef?.headerName
    this.popoverFields = this.getPopoverFields(this.params)
  },
}
</script>
